export default __webpack_public_path__ + "static/media/berlin-maroon-white.c7ba73ca.webp";